import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCard,
  SkeletonList,
  SkeletonListItem,
} from '@/components/common/skeleton';

export const LinkedAccountsListSkeleton: React.FC = () => (
  <SkeletonGroup>
    <SkeletonList count={3} gap={12}>
      <SkeletonCard>
        <SkeletonListItem avatar avatarSize={44} lines={2} lineWidths={[160, 120]} />
      </SkeletonCard>
    </SkeletonList>
  </SkeletonGroup>
);

export const InvitationsListSkeleton: React.FC = () => (
  <SkeletonGroup>
    <SkeletonList count={2} gap={12}>
      <SkeletonCard>
        <SkeletonListItem avatar avatarSize={44} lines={2} lineWidths={[140, 100]} />
        <View style={styles.buttonRow}>
          <SkeletonBone width={80} height={32} borderRadius={8} />
          <SkeletonBone width={80} height={32} borderRadius={8} />
        </View>
      </SkeletonCard>
    </SkeletonList>
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  buttonRow: {
    flexDirection: 'row',
    gap: 8,
    marginTop: 4,
  },
});
